import React, { useRef } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ClearIcon from '@material-ui/icons/Clear';

import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

const DataTableSearchToolbarWrapper = styled.div`
  width: 100%;
  input {
    width: 100%;
  }
`;

const DataTableSearchToolbar = ({ onClose, onChange, value }) => {
  const inputRef = useRef(null);
  return (
    <DataTableSearchToolbarWrapper>
      <TextField
        fullWidth
        autoFocus
        onChange={(event) => {
          onChange(event.target.value);
        }}
        value={value}
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position={'start'}>
              <IconButton onClick={onClose} size={'small'}>
                <ArrowBackIcon fontSize={'large'} />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position={'end'}>
              <IconButton
                size={'small'}
                onClick={() => {
                  onChange('');
                  inputRef.current.focus();
                }}>
                <ClearIcon fontSize={'large'} />
              </IconButton>
            </InputAdornment>
          ),
          inputRef: inputRef,
        }}
      />
    </DataTableSearchToolbarWrapper>
  );
};

DataTableSearchToolbar.propTypes = {
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default DataTableSearchToolbar;
